import type { Provider } from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';
import { i18nLoader } from './i18n-loader';

export function provideTranslocoScopeFactoryEditVirtualTour(): Provider {
  return provideTranslocoScope({
    scope: 'shared-factory-edit-virtual-tour',
    alias: 'factoryEditVirtualTour',
    loader: i18nLoader,
  });
}
